import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { capitalizeEachWord } from '../../helpers';
import { countryCodesName } from '../../constants/address';
import './styles.scss';

const EditAddressSuggestion = ({
  onClose, onAccept, address,
}) => (
  <div className="edit-address-suggestion">
    <div className="address">
      <p>{capitalizeEachWord(address.primaryLine)}</p>
      <p>{capitalizeEachWord(address.secondaryLine)}</p>
      <p>
        {`${capitalizeEachWord(address.city)}, ${address.state || ''} ${address.zip || ''}`}
      </p>
      <p>{capitalizeEachWord(get(countryCodesName, address.countryCode, '').replace('_', ' '))}</p>
    </div>
    <button type="button" className="fff-btn-primary" onClick={onClose}>EDIT ADDRESS</button>
    <button type="button" className="btn-link" onClick={onAccept}>Use unverified address</button>
  </div>
);

EditAddressSuggestion.defaultProps = {
  address: {},
  onClose: () => {},
  onAccept: () => {},
};

EditAddressSuggestion.propTypes = {
  address: PropTypes.shape({
    primaryLine: PropTypes.string,
    secondaryLine: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    countryCode: PropTypes.string,
    zip: PropTypes.string,
  }),
  onClose: PropTypes.func,
  onAccept: PropTypes.func,
};

export default EditAddressSuggestion;
